// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__URb0j","col":"styles_col__2KLuJ"};